import {
  SET_FEED_CONNECTED,
  SET_FEED_TEST_MESSAGE,
  SET_FEED_SOCKET_AUTHENTICATED,
} from './actionTypes';

import generateUniqueId from '../../../utils/generateUniqueId';

export const setConnected = (data) => ({
  type: SET_FEED_CONNECTED,
  payload: data,
});

export const setTestMessage = (data) => ({
  type: SET_FEED_TEST_MESSAGE,
  payload: {
    key: generateUniqueId(),
    message: data,
  },
});

export const setSocketAuthenticated = (data) => ({
  type: SET_FEED_SOCKET_AUTHENTICATED,
  payload: data,
});
